import script from "./evaluation.vue?vue&type=script&setup=true&lang=js"
export * from "./evaluation.vue?vue&type=script&setup=true&lang=js"

import "./evaluation.vue?vue&type=style&index=0&id=3bc153b6&lang=less"
import "./evaluation.vue?vue&type=style&index=1&id=3bc153b6&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc153b6"]])

export default __exports__